import { useState } from 'react';
import { MaterialType } from '@/interface.ts';
const speakerColorList = [
  {
    textColor: '#FFFFFF',
    bgColor: '#5EBFEC',
  },
  {
    textColor: '#FFFFFF',
    bgColor: '#7F43F9',
  },
  {
    textColor: '#FFFFFF',
    bgColor: '#FEA92A',
  },
  {
    textColor: '#FFFFFF',
    bgColor: '#F0514F',
  },
];

const layoutList = [
  {
    title: 'As_Edit_Ratio1',
    aspectRatio: '(16:9)',
    aspectRatioId: 0,
  },
  {
    title: 'As_Edit_Ratio2',
    aspectRatio: '(9:16)',
    aspectRatioId: 2,
  },
  {
    title: 'As_Edit_Ratio3',
    aspectRatio: '(9:16)',
    aspectRatioId: 2,
  },
  {
    title: 'As_Edit_Ratio4',
    aspectRatio: '(9:16)',
    aspectRatioId: 2,
  },
  {
    title: 'As_Edit_Ratio5',
    aspectRatio: '(1:1)',
    aspectRatioId: 1,
  },
  {
    title: 'As_Edit_Ratio6',
    aspectRatio: '(1:1)',
    aspectRatioId: 1,
  },
  {
    title: 'As_Edit_Ratio6',
    aspectRatio: '(9:16)',
    aspectRatioId: 2,
  },
  {
    title: 'As_Edit_Ratio7',
    aspectRatio: '(1:1)',
    aspectRatioId: 1,
  },
  {
    title: 'As_Edit_Ratio8',
    aspectRatio: '(9:16)',
    aspectRatioId: 2,
  },
  {
    title: 'As_Edit_Ratio9',
    aspectRatio: '(9:16)',
    aspectRatioId: 2,
  },
  {
    title: 'As_Edit_Ratio10',
    aspectRatio: '(1:1)',
    aspectRatioId: 1,
  },
  {
    title: 'As_Edit_Ratio11',
    aspectRatio: '(9:16)',
    aspectRatioId: 2,
  },
];
const editTargetLanguageList = [
  {
    id: 'en',
    name: 'English',
    language: 'English',
  },
  {
    id: 'fr',
    name: 'French',
    language: 'Français',
  },
  {
    id: 'es',
    name: 'Spanish',
    language: 'Español',
  },
  {
    id: 'de',
    name: 'German',
    language: 'Deutsch',
  },
  {
    id: 'ar',
    name: 'Arabic',
    language: 'العربية',
  },
  {
    id: 'ja',
    name: 'Japanese',
    language: '日本語',
  },
  {
    id: 'zh',
    name: 'Chinese',
    language: '中文',
  },
  {
    id: 'ko',
    name: 'Korean',
    language: '한국어',
  },
  {
    id: 'ru',
    name: 'Russian',
    language: 'Русский',
  },
  {
    id: 'nl',
    name: 'Dutch',
    language: 'Nederlands',
  },
  {
    id: 'it',
    name: 'Italian',
    language: 'Italiano',
  },
  {
    id: 'pl',
    name: 'Polish',
    language: 'Polski',
  },
  {
    id: 'pt',
    name: 'Portuguese',
    language: 'Português',
  },
];
const editOriginalLanguageList = [
  {
    id: 'en',
    name: 'English',
    language: 'English',
  },
  {
    id: 'fr',
    name: 'French',
    language: 'Français',
  },
  {
    id: 'es',
    name: 'Spanish',
    language: 'Español',
  },
  {
    id: 'de',
    name: 'German',
    language: 'Deutsch',
  },
  {
    id: 'ar',
    name: 'Arabic',
    language: 'العربية',
  },
  {
    id: 'ja',
    name: 'Japanese',
    language: '日本語',
  },
  {
    id: 'zh',
    name: 'Chinese',
    language: '中文',
  },
  {
    id: 'ko',
    name: 'Korean',
    language: '한국어',
  },
  {
    id: 'pt',
    name: 'Portuguese',
    language: 'Português',
  },
  {
    id: 'it',
    name: 'Italian',
    language: 'Italiano',
  },
  {
    id: 'ru',
    name: 'Russian',
    language: 'Русский',
  },
  {
    id: 'pl',
    name: 'Polish',
    language: 'Polski',
  },
  {
    id: 'hi',
    name: 'Hindi',
    language: 'हिन्दी',
  },
  {
    id: 'da',
    name: 'Danish',
    language: 'Dansk',
  },
  {
    id: 'fi',
    name: 'Finnish',
    language: 'Suomi',
  },
  {
    id: 'sv',
    name: 'Swedish',
    language: 'Svenska',
  },
  {
    id: 'nl',
    name: 'Dutch',
    language: 'Nederlands',
  },
  {
    id: 'ms',
    name: 'Malay',
    language: 'Bahasa Melayu',
  },
  {
    id: 'tl',
    name: 'Filipino',
    language: 'Filipino',
  },
  {
    id: 'id',
    name: 'Indonesian',
    language: 'Bahasa Indonesia',
  },
];

const languagesArray = ['th-th', 'zh', 'ja', 'ko', 'zh-hk', 'zh-tw', 'ug-cn'];
/**
 * 编辑页全局状态管理 hook
 * @returns {Object} 全局状态和更新方法
 */
export const useEditGlobal = () => {
  const [sessionId, setSessionId] = useState(''); // 全局点击事件监听
  const [projectDetail, setProjectDetail] = useState({}); // 全局点击事件监听
  const [clickOutsideListener, setClickOutsideListener] = useState(null); // 全局点击事件监听
  // 项目类型 0 重写 ，1翻译 ，2加字幕
  const [isTranslated, setIsTranslated] = useState(0);
  // true代表翻译false代表没翻译
  const [useTranslate, setUseTranslate] = useState(false);

  // 字幕展示 0 不展示字幕 ，1 展示原语言，2 展示翻译语言，3 展示双语字幕
  const [subtitleShow, setSubtitleShow] = useState(0);
  // translation_and_tts
  // translation
  // add_subtitle_and_translation
  // add_subtitle
  // rewrite
  const [mode, setMode] = useState('');

  // 当前激活的tab页签
  const [activeTab, setActiveTab] = useState('speech');
  // 句子数据
  const [sentences, setSentences] = useState([]);
  // 是否显示切换翻译语种的下拉框
  const [languageCheckShow, setLanguageCheckShow] = useState(false);
  // 是否显示音色列表
  const [showVoiceList, setShowVoiceList] = useState(false);
  // 说话人的数据列表
  const [speakerList, setSpeakerList] = useState([]);

  const [selectSpeakerItem, setSelectSpeakerItem] = useState({});

  // 当前播放或操作的句子索引（与subtitlePlayItem相同，需要联调整合）
  const [currentSentenceItem, setCurrentSentenceItem] = useState({});

  // 项目语音列表
  const [projectVoiceList, setProjectVoiceList] = useState([]);
  // 用户语音列表
  const [myVoiceList, setMyVoiceList] = useState([]);
  // AI语音列表
  const [aiVoiceList, setAiVoiceList] = useState([]);

  // 是否显示编辑字幕页面
  const [showEditCaptions, setShowEditCaptions] = useState(false);

  // 是否显示视频
  const [showVideo, setShowVideo] = useState(true);
  // 预设数据
  const [presetData, setPresetData] = useState({});
  // 播放的字幕数据
  const [subtitlePlayItem, setSubtitlePlayItem] = useState({});
  // 播放的译文字幕数据
  const [subtitleBilingualPlayItem, setSubtitleBilingualPlayItem] = useState({});
  // 选中字幕id
  const [captionsId, setCaptionsId] = useState('');
  // 选中翻译字幕id
  const [newcaptionsId, setNewcaptionsId] = useState('');
  // 字幕样式数据
  const [captionsItem, setCaptionsItem] = useState({});
  // 翻译字幕样式数据
  const [newcaptionsItem, setNewCaptionsItem] = useState({});
  // 播放时间
  const [subtitleTime, setSubtitleTime] = useState(0);
  // 自定义layout
  const [diyLayout, setDiyLayout] = useState({});
  // 背景图
  const [bgItem, setBgItem] = useState({});
  // 时间轴播放时间字段
  const [timelinePlaybackTime, setTimelinePlaybackTime] = useState(0);

  // 原文字幕位置和大小配置
  const [subtitleBox, setSubtitleBox] = useState({});

  // 译文字幕位置和大小配置
  const [translationSubtitleBox, setTranslationSubtitleBox] = useState({});
  // 双语字幕位置和大小配置
  const [bilingualismSubtitleBox, setBilingualismSubtitleBox] = useState({});

  const [diyContentStyle, setDiyContentStyle] = useState({});

  const [videoMaterial, setVideoMaterial] = useState({});
  const [sentenceMaterial, setSentenceMaterial] = useState({});
  const [musicMaterial, setMusicMaterial] = useState({});
  const [translationMaterial, setTranslationMaterial] = useState({});
  const [materialSorted, setMaterialSorted] = useState(false);

  const [translationLanguage, setTranslationLanguage] = useState('');

  const [subtitleUpdateFlag, setSubtitleUpdateFlag] = useState(0);
  const [translationSubtitleUpdateFlag, setTranslationSubtitleUpdateFlag] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const [changeVoiceEditSentence, setChangeVoiceEditSentence] = useState({
    item: {},
    date: 0,
  });
  const [seppchScroll, setSeppchScroll] = useState(false);
  const [subtitleScroll, setSubtitleScroll] = useState(false);

  const [subtitleSegmentationCount, setSubtitleSegmentationCount] = useState(6); // 字幕分词数量

  const [seppchHover, setSeppchHover] = useState(false);
  const [subtitleHover, setSubtitleHover] = useState(false);
  // 输入框是否聚焦
  const [isInputFocused, setIsInputFocused] = useState(false);
  // 用户信息
  const [userDetail, setUserDetail] = useState({});
  // 价格表
  const [priceList, setpriceList] = useState([]);
  // 全局loading控制
  const [editPageLoading, setEditPageLoading] = useState(false);
  const [fontSizeBox, setFontSizeBox] = useState(false);
  const [doubleFontSizeBox, setDoubleFontSizeBox] = useState(false);

  function sortByTimeLineFrom(array) {
    // 创建数组副本以避免修改原数组
    const sortedArray = [...array];

    // 根据timeLineFrom属性进行排序
    sortedArray.sort((a, b) => {
      if ([MaterialType.AUDIO, MaterialType.TRANSLATION].includes(a.type)) {
        if (a.timeLineFrom === b.timeLineFrom) {
          if (!a.sentence && b.sentence) {
            return -1;
          } else {
            return 1;
          }
        }
      }
      return a.timeLineFrom - b.timeLineFrom;
    });

    return sortedArray;
  }

  // 返回所有状态和更新方法
  return {
    editTargetLanguageList,
    editOriginalLanguageList,
    sessionId,
    setSessionId,
    sortByTimeLineFrom,
    projectDetail,
    setProjectDetail,
    layoutList,
    speakerColorList,
    activeTab,
    setActiveTab,
    sentences,
    setSentences,
    isTranslated,
    setIsTranslated,
    currentSentenceItem,
    setCurrentSentenceItem,
    speakerList,
    setSpeakerList,
    showVoiceList,
    setShowVoiceList,
    projectVoiceList,
    setProjectVoiceList,
    myVoiceList,
    setMyVoiceList,
    aiVoiceList,
    setAiVoiceList,
    languageCheckShow,
    setLanguageCheckShow,
    clickOutsideListener,
    setClickOutsideListener,
    showEditCaptions,
    setShowEditCaptions,
    showVideo,
    setShowVideo,
    diyLayout,
    setDiyLayout,
    presetData,
    setPresetData,
    bgItem,
    setBgItem,
    subtitlePlayItem,
    setSubtitlePlayItem,
    subtitleBilingualPlayItem,
    setSubtitleBilingualPlayItem,
    captionsItem,
    setCaptionsItem,
    subtitleTime,
    setSubtitleTime,
    subtitleBox,
    setSubtitleBox,
    translationSubtitleBox,
    setTranslationSubtitleBox,
    newcaptionsItem,
    setNewCaptionsItem,
    diyContentStyle,
    setDiyContentStyle,
    videoMaterial,
    setVideoMaterial,
    sentenceMaterial,
    setSentenceMaterial,
    musicMaterial,
    setMusicMaterial,
    translationMaterial,
    setTranslationMaterial,
    materialSorted,
    setMaterialSorted,
    subtitleShow,
    setSubtitleShow,
    captionsId,
    setCaptionsId,
    newcaptionsId,
    setNewcaptionsId,
    timelinePlaybackTime,
    setTimelinePlaybackTime,
    translationLanguage,
    setTranslationLanguage,
    useTranslate,
    setUseTranslate,
    bilingualismSubtitleBox,
    setBilingualismSubtitleBox,
    subtitleUpdateFlag,
    setSubtitleUpdateFlag,
    translationSubtitleUpdateFlag,
    setTranslationSubtitleUpdateFlag,
    changeVoiceEditSentence,
    setChangeVoiceEditSentence,
    selectSpeakerItem,
    setSelectSpeakerItem,
    isInputFocused,
    setIsInputFocused,
    userDetail,
    setUserDetail,
    mode,
    setMode,
    priceList,
    setpriceList,
    editPageLoading,
    setEditPageLoading,
    seppchScroll,
    setSeppchScroll,
    subtitleScroll,
    setSubtitleScroll,
    isPlaying,
    setIsPlaying,
    seppchHover,
    setSeppchHover,
    subtitleHover,
    setSubtitleHover,
    languagesArray,
    subtitleSegmentationCount,
    setSubtitleSegmentationCount,
    fontSizeBox,
    setFontSizeBox,
    doubleFontSizeBox,
    setDoubleFontSizeBox,
  };
};
